import React from "react";
import Modal from "../../../components/Modal";
import type { SchoolCalendarEvent } from "../types";

interface DeleteEventModalProps {
  t: any;
  deleteTarget: SchoolCalendarEvent | null;
  setDeleteTarget: (event: SchoolCalendarEvent | null) => void;
  handleDelete: () => void;
}

const DeleteEventModal = ({ t, deleteTarget, setDeleteTarget, handleDelete }: DeleteEventModalProps) => (
  <Modal
    show={Boolean(deleteTarget)}
    type="confirm"
    title={t("schoolCalendar.deleteTitle", { defaultValue: "Planning-item verwijderen" })}
    message={
      <>
        <p>
          Weet je zeker dat je het volgende planning-item wilt verwijderen?
        </p>

        <p className="mt-3 rounded-lg bg-gray-100 px-3 py-2 font-semibold dark:bg-gray-800">
          "{deleteTarget?.title}"
        </p>
      </>
    }
    onConfirm={handleDelete}
    onClose={() => setDeleteTarget(null)}
  />
);

export default DeleteEventModal;
